/* eslint-disable compat/compat */
// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class MediaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 0,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.1,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.prev?.element,
        }),
        this.useCurrentSlideIndicator(
          this.els?.totalPage?.element,
          '{{ current }}/{{ total }}',
        ),
      ],
    )
  }

  useCurrentSlideIndicator = (indicator, template = '{{ current }}') => {
    /** @param {KeenSliderInstance} carousel */
    return carousel => {
      const updateIndicator = () => {
        const { rel, maxIdx } = carousel.track.details
        const current = String(rel + 1)
        const total = String(maxIdx + 1)
        indicator.textContent = window.BAO.Utils.translateString(template, {
          current,
          total,
        })
      }

      carousel.on('created', updateIndicator)
      carousel.on('slideChanged', updateIndicator)
      carousel.on('optionsChanged', updateIndicator)
    }
  }
}

if (!customElements.get('media-carousel')) {
  customElements.define('media-carousel', MediaCarousel)
}
